<!--
  <FileInput
    :props="my_attrs_dictionary"
  />

  Public propertys:
    value → File() object

  Public methods:
    validate → Makes validation and returns if the value is valid

  Accepted props:
  - value (file url)
  - required_rule
  - accept

  .. note: if props.readonly is true input file component will not be
    rendered
  
-->

<template>
  <div>
    <v-file-input
      v-if="!props.readonly"
      :disabled="props.readonly || props.disabled"
      v-model="file"
      :label="props.label"
      :placeholder="props.placeholder"
      dense
      :accept="!props.accept ? '/*' : props.accept"
      :rules="[max_size, is_required, file_extension]"
      :class="[props.class || 'qmkey-form-input', { required: props.required }]"
      @change="update"
    >
      <!-- <template v-slot:selection="{ index, text }">
        <span>
          {{ file ? text : props.filename || text }}
        </span>
      </template> -->
    </v-file-input>
    <div v-if="props.filename">
      <span class="overline">
        {{ $vuetify.lang.translator('inputs.current_file') }}:
      </span>
      <span>
        <v-icon
          small
          class="mr-2"
          :color="files[props.mimetype].color"
          @click="download"
          v-if="props.mimetype"
          :disabled="!props.value"
        >
          {{ files[props.mimetype].icon }}
        </v-icon>
      </span>
      <span>
        {{ props.filename }}
      </span>
      <v-btn
          small
          icon
          @click="download"
          :disabled="!props.value"
        >
          <v-icon
            small
            class="mr-2"
          >
            mdi-download
          </v-icon>
        </v-btn>
      
    </div>
  </div>
</template>

<script>
import QUnitAPI from '@/api/QUnit'
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import FileIcons from '@/utils/fileicons'

export default {
  name: 'FileInput',

  props: ['props', 'required_rule', 'accept', 'current_unit'],

  data: () => ({
    file: null,
    files: FileIcons,
  }),

  computed: {
    value() {
      return this.file || this.props.value
    },
    ...mapGetters(['centro_id']),
    ...mapState([
      'isLoading',
      'message',
    ]),

    size() {
      return (this.value || {}).size || 0;
    }
  },

  methods: {
    validate() {
      return !this.required || !!this.file
    },

    // validators
    is_required(value) {
      return !this.props.required || (!!value || !!this.props.value);
    },

    max_size(value) {
      // TODO when we have per-site limits implemented, capture proper value here
      let MAX_SIZE = 20 * 2**20; // 20 MiB
      // TODO translation should be aware of the actual limit
      return !value || value.size < MAX_SIZE || this.$vuetify.lang.translator('inputs.file_too_big');
    },

    file_extension(value) {
      if (!value) {
        return true;
      }
      
      const extension = (value.name.slice((value.name.lastIndexOf(".") - 1 >>> 0) + 2));
      let valid_extension = true;
      if (this.props.file_extension && this.props.file_extension.length > 0) {
        //valid_extension = this.props.file_extension.includes(extension);
      }

      if (!valid_extension) {
        return this.$vuetify.lang.translator('inputs.file_not_valid');
      } else {
        return true;
      }
    },

    async download() {
        if (this.current_unit){
          const data = QUnitAPI.getQUnitFile(
            this.centro_id,
            this.current_unit.uid,
            this.props.id,
            this.props.value,
            0,
            this.props.filename,
          ).then((data)=>{
            this.downloadFile(data, this.props.filename);
          });
      }
    },

    downloadFile(data, filename) {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([data.data], { type: 'application/vnd' })

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob)
        return
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const ob = window.URL.createObjectURL(newBlob)
      var link = document.createElement('a')
      link.href = ob
      link.download = filename //+ '.docx'
      link.click()
      setTimeout(function() {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(ob)
      }, 100)
    },

    update(value) {
      this.$emit('update',value);
    },
  },

  // watch: {
  //   props(props) {
  //     if (!this.file && props.filename) this.file = File()
  //   },
  // },
  // watch: {
  //    props: {
  //      deep: true,
  //      value(val) {
  //        this.update_file(val);
  //      },
  //      handler() {
  //        // Other property changes get ignored
  //      },
  //    },
  //  },
}
</script>
